import React from 'react';
import PatientInfoStack from 'Routes/Protected/CurrentPatients/Components/EachPatient/component/PatientInfoStack';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const PatientInfoSummurary = ({ Patient }) => {
  const cachedIcons = JSON.parse(
    localStorage.getItem('icons')
  );
  const imgHeader = 'data:image/svg+xml;base64,';

  return (
    <React.Fragment>
      <PatientInfoStack
        ImageSource={
          imgHeader +
          cachedIcons?.MenueIcon['patient name.svg']
        }
        paragraph={`بیمار: ${ArabicToPersian(
          Patient?.NamePatient
        )} ${ArabicToPersian(Patient?.FamilyPatient)}`}
      />
      <PatientInfoStack
        ImageSource={
          imgHeader +
          cachedIcons?.MenueIcon['NationalCode.svg']
        }
        paragraph={`کدملی/شناسه: ${ArabicToPersian(
          Patient?.FldNationalCode
        )} -- ${ArabicToPersian(Patient?.IdPatient)}`}
      />
      <PatientInfoStack
        ImageSource={
          imgHeader +
          cachedIcons?.MenueIcon['Hospital department.svg']
        }
        paragraph={`واحد: ${ArabicToPersian(
          Patient.NameHospitaldept
        )}`}
      />
      <PatientInfoStack
        ImageSource={
          imgHeader +
          cachedIcons?.MenueIcon['DateAttendance.svg']
        }
        paragraph={`تاریخ مراجعه: ${ArabicToPersian(
          Patient.InsertDate
        )}   ${Patient.InsertTime}`}
      />
      <PatientInfoStack
        ImageSource={
          imgHeader +
          cachedIcons?.MenueIcon['Turn number.svg']
        }
        paragraph={`شماره نوبت: ${Patient.FldPeriod}`}
      />
    </React.Fragment>
  );
};

export default PatientInfoSummurary;
